import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../public/icons/workflow/close.svg'
import _imports_1 from '../../../public/icons/help.svg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.useModalDialogsV2 ? 'modal-maskV2' : 'modal-mask'),
            style: _normalizeStyle(_ctx.maskCss)
          }, [
            _createElementVNode("div", {
              class: "modal-wrapper",
              style: _normalizeStyle(_ctx.wrapperCss)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(['modal-container', _ctx.containerStyle, _ctx.useModalDialogsV2 ? 'modal-containerV2' : '']),
                style: _normalizeStyle(_ctx.containerCss)
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.useModalDialogsV2 ? 'modal-headerV2' : 'modal-header')
                }, [
                  _createElementVNode("div", {
                    style: _normalizeStyle(_ctx.useModalDialogsV2 ? {width: '100%'} : {paddingTop: '10px', paddingRight: '12px', paddingBottom: '6px', paddingLeft: '12px', width: '100%', height: '41px'})
                  }, [
                    _renderSlot(_ctx.$slots, "header", {}, () => [
                      _createTextVNode(_toDisplayString(_ctx.Localizer.Localize("Modal_default_header")), 1)
                    ], true),
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: _normalizeClass(["theme-svg", {md:_ctx.size==='md'}]),
                      id: "close",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                    }, null, 2),
                    (_ctx.Can_OpenHelp)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _imports_1,
                          class: _normalizeClass(["theme-svg", {md:_ctx.size==='md'}]),
                          id: "help",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.OpenHelp && _ctx.OpenHelp(...args)))
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ], 4)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.useModalDialogsV2 ? 'modal-bodyV2' : 'modal-body')
                }, [
                  _renderSlot(_ctx.$slots, "body", {}, () => [
                    _createTextVNode(_toDisplayString(_ctx.Localizer.Localize("Modal_default_body")), 1)
                  ], true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.useModalDialogsV2 ? 'modal-footerV2' : 'modal-footer'),
                  style: _normalizeStyle(_ctx.footerCss)
                }, [
                  _renderSlot(_ctx.$slots, "footer", {}, () => [
                    _createTextVNode(" default footer "),
                    _createElementVNode("button", {
                      class: "modal-default-button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
                    }, _toDisplayString(_ctx.Localizer.Localize("OK")), 1),
                    _createElementVNode("button", {
                      class: "modal-default-button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
                    }, _toDisplayString(_ctx.Localizer.Localize("OK")), 1)
                  ], true)
                ], 6)
              ], 6)
            ], 4)
          ], 6))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}